import { observer } from "mobx-react-lite";
import { useStore } from "../../../stores";
import type { BaseComponentProps } from "../base/types";

const LABELS: Record<string, string> = {
  en: "EN",
  ru: "RU",
  ja: "日本語",
};

// Order of languages for cycling
const LANGUAGE_ORDER = ["en", "ru", "ja"] as const;

export const LanguageSwitcher = observer(
  ({ className }: BaseComponentProps) => {
    const { uiStore } = useStore();
    const { locale, setLocale } = uiStore;

    const cycleLanguage = () => {
      const currentIndex = LANGUAGE_ORDER.indexOf(locale);
      const nextIndex = (currentIndex + 1) % LANGUAGE_ORDER.length;
      const nextLocale = LANGUAGE_ORDER[nextIndex] as typeof locale;
      setLocale(nextLocale);
    };

    return (
      <button
        type="button"
        onClick={cycleLanguage}
        className={`bg-transparent border-0 shadow-none text-sm focus:outline-none font-medium no-underline p-2 rounded-lg hover:bg-gray-100 text-gray-500 hover:text-gray-900 transition-colors ${className ?? ""}`.trim()}
        aria-label={`Current language: ${LABELS[locale]}. Click to change.`}
      >
        {LABELS[locale]}
      </button>
    );
  },
);
